// extracted by mini-css-extract-plugin
export default {"container":"WQ-z","dimension":"XQ-z","dimensionLabels":"YQ-z"};